<div class="wrapper overflow" [ngClass]="classes">
  <ng-content></ng-content>
</div>
